import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Post from '../components/Post';
import Pagination from '../components/Pagination';
import { SharedHead } from '../components/SharedHead';

export const Head = () => <SharedHead />;

const IndexPage = ({ data, pageContext }) => {
  const posts = data.allWordpressPost.edges;
  const postList = posts.map((edge) => (
    <Post key={edge.node.slug} post={edge.node} />
  ));

  return (
    <Layout>
      <div className="post-list">{postList}</div>
      <Pagination pageContext={pageContext} />
    </Layout>
  );
};

IndexPage.propTypes = {
  data: PropTypes.shape({
    edges: PropTypes.array,
  }),
  pageContext: PropTypes.shape({
    currentPage: PropTypes.number,
    numPages: PropTypes.number,
  }),
};

export const pageQuery = graphql`
  query IndexQuery($limit: Int!, $skip: Int!) {
    allWordpressPost(sort: { date: DESC }, limit: $limit, skip: $skip) {
      edges {
        node {
          slug
          title
          date(formatString: "M.D.YY")
          content
          categories {
            name
            slug
          }
          tags {
            name
            slug
          }
        }
      }
    }
  }
`;

export default IndexPage;
